/**
 * The open view's title, blurb, icon and tone, as the workbench page's view table has them. Each
 * view's title line reads it from here, so the title and blurb live in one place and match the
 * navigation.
 */

import { createContext, type ReactNode, useContext } from 'react';

import type { ArtTone } from '../components/ui/Art.tsx';

export interface ViewMeta {
  title: string;
  subtitle: string;
  icon: ReactNode;
  tone: ArtTone;
}

export const ViewMetaContext = createContext<ViewMeta | undefined>(undefined);

export function useViewMeta(): ViewMeta {
  const meta = useContext(ViewMetaContext);
  if (!meta) throw new Error('A machine view renders inside the workbench page');
  return meta;
}
